import type { ReadResult } from './read'

/**
 * A comment or reply under a saved post is not something the person saved: a Substack note's first reply, read as a second post on the
 * same screenshot, came out as its own card. A post whose screenshots all belong to an earlier post on the same platform is taken as a
 * reply on that screen and left out, whoever wrote it. Posts on screenshots of their own (a carousel, a thread across screens) stay.
 */
export function withoutReplies(result: ReadResult): ReadResult {
  const items = result.items.filter((item, index) => item.kind !== 'post' || !item.images.length || !result.items.slice(0, index).some(earlier =>
    earlier.kind === 'post' && earlier.platform === item.platform && item.images.every(image => earlier.images.includes(image))))
  return items.length === result.items.length ? result : { ...result, items }
}
